module.exports = __webpack_public_path__ + "static/media/gryphon_musee_abovethetrees_brentcomber_1.06abf800.jpg";